<template>
  <div>
    <RevDrawer
      :closeButtonLabel="i18n(translations.close)"
      name="modal.customer-reviews.filters.mobile"
      :title="i18n(translations.title)"
    >
      <template #body>
        <form>
          <div class="flex flex-col space-y-4">
            <RevInputText
              id="order-id"
              v-model="filtersValues.orderId"
              :label="i18n(sharedTranslations.orderNumber)"
            />
            <InputSelectMarket v-model="filtersValues.market as string" />
            <RevInputDate
              id="start-date"
              v-model="filtersValues.startDate"
              :label="i18n(sharedTranslations.startDate)"
              type="date"
            />
            <RevInputDate
              id="end-date"
              v-model="filtersValues.endDate"
              :label="i18n(sharedTranslations.endDate)"
              type="date"
            />
            <InputSelectCategory v-model="filtersValues.categoryId as string" />
            <RevInputText
              id="min-rate"
              v-model="filtersValues.minRate"
              :label="i18n(sharedTranslations.ratingMin)"
              :max="RATE.MAX"
              :min="RATE.MIN"
              type="number"
            />
            <RevInputText
              id="max-rate"
              v-model="filtersValues.maxRate"
              :label="i18n(sharedTranslations.ratingMax)"
              :max="RATE.MAX"
              :min="RATE.MIN"
              type="number"
            />
          </div>
        </form>
      </template>
      <template #footer="{ close }">
        <div class="flex">
          <RevButton
            class="mr-1"
            full-width="always"
            type="submit"
            variant="primary"
            @click="handleSubmit(close)"
          >
            {{ i18n(sharedTranslations.submit) }}
          </RevButton>

          <RevButton
            full-width="always"
            variant="secondary"
            @click="handleReset(close)"
          >
            {{ i18n(sharedTranslations.reset) }}
          </RevButton>
        </div>
      </template>
      <template #trigger="{ open }">
        <RevStickyBar>
          <div class="flex items-center justify-center">
            <RevButton
              :icon="IconEqualizer"
              size="small"
              variant="secondary"
              @click="open"
            >
              {{ i18n(sharedTranslations.filter) }}
            </RevButton>
          </div>
        </RevStickyBar>
      </template>
    </RevDrawer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevInputDate } from '@ds/components/InputDate'
import { RevInputText } from '@ds/components/InputText'
import { RevStickyBar } from '@ds/components/StickyBar'
import { IconEqualizer } from '@ds/icons/IconEqualizer'

import { RATE } from '../../Filters.constants'
import sharedTranslations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

import translations from './FiltersMobile.translations'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

const props = defineProps<{
  resetFilters: () => void
  submitFilters: () => void
}>()

const i18n = useI18n()

function handleSubmit(closeModal: () => void) {
  props.submitFilters()
  closeModal()
}

function handleReset(closeModal: () => void) {
  props.resetFilters()
  closeModal()
}
</script>
